import { Alarm } from "./alarm";
import { Notifications } from "./notifications";

export class AlarmProfile {
  private source_id: string;
  private client_id: string;
  private active: boolean;
  private id: string;
  private name: string;
  private description: string;
  private notifications: Notifications;
  private alarms: Alarm[];
  private justCreated: boolean;
  observers: Set<() => void> = new Set();

  constructor(
    source_id: string,
    client_id: string,
    active: boolean,
    id: string,
    name: string,
    description: string,
    notifications: Notifications,
    alarms: Alarm[],
    justCreated: boolean,
  ) {
    this.setSourceId(source_id);
    this.setClientId(client_id);
    this.setActive(active);
    this.setId(id);
    this.setName(name);
    this.setDescription(description);
    this.setNotifications(notifications);
    this.setAlarms(alarms);
    this.setJustCreated(justCreated);
  }

  getSourceId() {
    return this.source_id;
  }

  getClientId() {
    return this.client_id;
  }

  getActive() {
    return this.active;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getNotifications() {
    return this.notifications;
  }

  getAlarms() {
    return this.alarms;
  }

  getJustCreated() {
    return this.justCreated;
  }

  setSourceId(source_id: string) {
    this.source_id = source_id;
  }

  setClientId(client_id: string) {
    this.client_id = client_id;
  }

  setActive(active: boolean) {
    this.active = active;
  }

  setId(id: string) {
    this.id = id;
  }

  setName(name: string) {
    this.name = name;
    this.notifyObservers();
  }

  setDescription(description: string) {
    this.description = description;
  }

  setNotifications(notifications: Notifications) {
    this.notifications = notifications;
  }

  setAlarms(alarms: Alarm[]) {
    this.alarms = alarms;
  }

  setJustCreated(justCreated: boolean) {
    this.justCreated = justCreated;
  }

  getAlarmById(id: string) {
    return this.alarms.find((alarm) => alarm.getOurNode().id === id);
  }

  getActiveAlarms() {
    return this.alarms.reduce((result, alarm) => {
      if (alarm.getActive() && !alarm.getComputed()) {
        result[alarm.getOurNode().id] = alarm;
      }
      return result;
    }, {});
  }

  getInactiveAlarms() {
    return this.alarms.reduce((result, alarm) => {
      if (!alarm.getActive() && !alarm.getComputed()) {
        result[alarm.getOurNode().id] = alarm;
      }
      return result;
    }, {});
  }

  getComputedAlarms() {
    return this.alarms.reduce((result, alarm) => {
      if (alarm.getComputed()) {
        result[alarm.getOurNode().id] = alarm;
      }
      return result;
    }, {});
  }

  toJSON() {
    return {
      source_id: this.source_id,
      client_id: this.client_id,
      active: this.active,
      // id: this.id, // id is not sent for put on all profiles but might be used on single put in the future
      name: this.name,
      description: this.description,
      notifications: this.notifications.toJSON(),
      /*  alarms: this.alarms.map((alarm) => alarm.toJSON()), */
      active_alarms: this.getActiveAlarms(),
      inactive_alarms: this.getInactiveAlarms(),
      kpi_alarms: this.getComputedAlarms(),
    };
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
